import React from 'react';
import { motion } from 'framer-motion';
import ScoreDisplay from './ScoreDisplay';
import SocialMediaSection from './SocialMediaSection';
import RedditSection from './RedditSection';
import StoriesSection from './StoriesSection';
import ImagesSection from './ImagesSection';
import ContactSection from './ContactSection';
import WorkEducationSection from './WorkEducationSection';
import RedFlagsSection from './RedFlagsSection';
import FinalAssessment from './FinalAssessment';

const ResearchReport = ({ data }) => {
  const getAssessmentColor = (score) => {
    if (score >= 90) return 'text-green-400';
    if (score >= 70) return 'text-blue-400';
    if (score >= 40) return 'text-yellow-400';
    return 'text-red-400';
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="max-w-6xl mx-auto space-y-8"
    >
      {/* Header */}
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-white mb-2">🔎 PERSON RESEARCH REPORT</h2>
          <div className="text-2xl font-semibold text-white mb-4">Name: {data.name}</div>
          <div className={`text-xl font-medium mb-2 ${getAssessmentColor(data.score)}`}>
            Preliminary Assessment: {data.assessment}
          </div>
        </div>
        <ScoreDisplay score={data.score} />
      </div>

      {/* Reddit Section - Display Reddit posts if available */}
      <RedditSection redditPosts={data.redditPosts} />

      {/* Images Section - Display images if available */}
      <ImagesSection images={data.images} />

      {/* Google Search Results Section */}
      <StoriesSection stories={data.stories} />

      {/* Social Media Section */}
      <SocialMediaSection socialMedia={data.socialMedia} />

      {/* Contact Information */}
      <ContactSection contactInfo={data.contactInfo} />

      {/* Work & Education */}
      <WorkEducationSection workHistory={data.workHistory} education={data.education} />

      {/* Red Flags */}
      <RedFlagsSection redFlags={data.redFlags} />

      {/* Final Assessment */}
      <FinalAssessment assessment={data.finalAssessment} score={data.score} />
    </motion.div>
  );
};

export default ResearchReport;